import { Chip } from '@mui/material'
import React from 'react'

export const UnsharedNamespaceChip: React.FC<{
  namespace: string
  isSelected: boolean
  onClick(): void
}> = ({ namespace, isSelected, onClick }) => {
  return (
    <Chip
      color={isSelected ? 'success' : 'default'}
      data-testid={`chip-unshared-namespace-${namespace}`}
      label={namespace}
      sx={{ margin: 0.5, width: 'fit-content' }}
      onClick={onClick}
    />
  )
}
